export class Address {
    id: string
    zipcode: string = ''
    houseNumber: string
    houseNumberSuffix?: string = ''
    street: string = ''
    city: string = ''
}
